exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1383fd9d] .el-button--mini {\n  background: #22c655;\n  color: #fff;\n}", ""]);

// exports
